module.exports = __webpack_public_path__ + "static/244-1148d4ab3ec03dc140313ff4ee5377bb.jpg";